<button
  [disabled]="disabled()"
  (click)="remove()"
  [ngbTooltip]="'addToCart.cart.removeBtnLabel' | transloco"
  [tooltipClass]="'ngb-boels-tooltip'"
  [autoClose]="'inside'"
  container="body"
  data-boundary="viewport"
>
  <fa-icon [icon]="trashIcon"></fa-icon>
</button>
